<template>
  <div class="vasion-white-background vasion-calc-height ">
    <Loading
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="inner-div">
      <div class="md-layout">
        <div class="md-layout-item vasion-page-title">
          About Vasion
        </div>
      </div>
      <div class="last-update">{{ lastUpdateDate }}</div>
      <div class="grid-div vasion-html-table-default">
        <VasionTable
          :headerColumns="ColumnValues"
          :tableRows="tableData.Rows.Values"
          :filterByColumnDefault="1"
          :clickableRows="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { parseISO, format } from 'date-fns'

// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  name: 'AboutVasion',
  components: {
    Loading,
  },
  data: function () {
    return {
      ColumnValues: [
        'Component',
        'Version',
        'Release Date',
      ],
      isLoading: false,
      lastUpdateDate: '',
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      tableData: {
        Rows: {
          Values: [],
        },
      },
    }
  },
  computed: {
    uiVersion() { return this.$store.state.admin.uiVersion }
  },
  async created() {
    await this.refreshTable()
  },
  methods: {
    async refreshTable() {
      this.isLoading = true

      if (!this.uiVersion) {
        await (this.$store.dispatch('admin/getUiVersion'))
      }
      const appVersions = await this.$store.dispatch('admin/getAppVersions')
      this.lastUpdateDate = 'The Vasion API site was last updated on ' + (appVersions.UpdateDate ? format(parseISO(appVersions.UpdateDate), 'MMMM dd yyyy') : "") + '.'

      this.tableData = {
        Rows: {
          Values: [],
        },
      }
      appVersions.Apps.forEach(app => {
        this.tableData.Rows.Values.push({
          Values: [
            app.AppName,
            app.Version,
            app.ReleaseDate ? format(parseISO(app.ReleaseDate), 'MMM dd yyyy') : "",
          ]
        })
      })

      this.tableData.Rows.Values.push( {
        Values: [
          "UI",
          this.uiVersion,
          "",
        ],
      })
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/variables.scss';

  .inner-div {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 10px;
  }

  .grid-div {
    height: calc(100vh - 120px);
    width: 600px;
    margin-top: 10px;
    overflow: auto;
  }

  .last-update {
    margin-top: 10px;
  }
</style>
